
<div class="header-search-mobile">
  <form @submit.prevent="submit" class="search-form">
    <ais-instant-search
      :search-client="searchClient"
      :search-function="searchFunction"
      index-name="diaceutics_website_query_suggestions"
    >
      <ais-configure
        :hitsPerPage="5"
      />
      <span class="place-holder" v-if="!active" @click="setActive">Tap to search</span>
      <ais-autocomplete v-if="active">
        <template slot-scope="{ currentRefinement, indices, refine }">
          <vue-autosuggest
            v-model="query"
            :suggestions="indicesToSuggestions(indices)"
            :get-suggestion-value="getSuggestionValue"
            @keyup.enter="submit"
            @input="refine"
            :input-props="{
              id: 'search-input-mobile',
              placeholder: 'Tap to search',
              autoFocus: true,
            }"
          >
            <template slot-scope="{ suggestion }">
              <span class="suggestion" @mousedown="onSelect(suggestion.item.query)">{{ suggestion.item.query }}</span>
            </template>
          </vue-autosuggest>
        </template>
      </ais-autocomplete>
    </ais-instant-search>
  </form>
  <i class="icon icon--search--mobile" />
</div>
